import CLink from "../CLink"
import { useMisc } from "../../contexts/MiscContext";

import "./Tag.scss";

export default function Tag({ tag, openInNewTab }: { tag: string, openInNewTab?: boolean }) {

    const { convertSnakeTagsToTitle } = useMisc();

    return (
        <CLink
            to={`/tags/${tag}`}
            target={ (!!openInNewTab) && "_blank"}
            className={`tag ${tag}`}
            key={tag}
        >
            {convertSnakeTagsToTitle(tag)}
        </CLink>
    )
};